import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./auth.scss";
import ResetPasswordForm from "./forms/ResetPasswordForm";


const ResetPassowrd = () => {
  const navigate = useNavigate();

  return (
    <section className="auth-section">
      <div className="left">
        <div className="img-wrap">
          <Link to="/">
            <img src="/images/logo.svg" width={100} height={100} alt="Logo" />
          </Link>
        </div>
      </div>

      <div className="right">
        <ResetPasswordForm onResetPasswordSuccess={() => {navigate("/login");}}/>
      </div>
    </section>
  );
};

export default ResetPassowrd;
